import React, { useEffect } from 'react';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { observer } from 'mobx-react-lite';
import { useStore } from '../store/index';
import { pageLoadEvents, errorEvents } from '../utils/analytics';
import { NotificationsProvider } from '../components/NotificationsProvider/NotificationsProvider';

import SplashPage from '../components/Home/SplashPage';

export const Home = observer(() => {

  const {
    authStore: { authInProgress, initAuth },
  } = useStore();

  useEffect(() => {
    pageLoadEvents.landingPage();

    // authorize and send error analytics as callback if not authorized
    initAuth(errorEvents.postPageError);

    if (document.referrer.includes('b2b/account/view/landingpage')) {
      pageLoadEvents.landingPageReferFromMyAccount();
    } else if (document.referrer.includes('myaccount/profile')) {
      pageLoadEvents.landingPageReferFromMyAccountSideBar();
    }
  }, []);

  if (authInProgress) {
    return (
      <ErrorBoundary name="home-page">
        <NotificationsProvider>
          <div />
        </NotificationsProvider>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary name="home-page">
      <NotificationsProvider>
        <SplashPage />
      </NotificationsProvider>
    </ErrorBoundary>
  );
});
